export { default as postReducer } from "./postSlice";
export { default as postThunks } from "./thunks";
// export { default as postActions } from './actions';
